'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

/**
 * GTM Page View Tracker Component
 *
 * This component tracks route changes in Next.js App Router and sends
 * page view events to the analytics dataLayer (server-side GTM).
 *
 * It should be placed in the layout to track all navigation changes.
 */
export function GTMPageViewTracker() {
	const pathname = usePathname()
	const searchParams = useSearchParams()

	useEffect(() => {
		// Only run on client side
		if (typeof window === 'undefined') return

		// Initialize dataLayer if it doesn't exist
		window.dataLayer = window.dataLayer || []

		// Construct the full URL with search params
		// const url = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '')

		// Push the page view event to GTM
		// This triggers a virtual pageview in GA4 when configured in GTM
		window.dataLayer.push({
			event: 'page_view',
			page_path: pathname,
			page_location: window.location.href,
			page_title: document.title
		})

		// Uncomment for debugging:
		// console.log('GTM Page View:', { page_path: pathname, page_location: window.location.href })
	}, [pathname, searchParams])

	// This component doesn't render anything
	return null
}

// Extend the global Window interface to include dataLayer
declare global {
	interface Window {
		dataLayer: any[]
	}
}
